module.exports = __webpack_public_path__ + "img/cover-speaky.07bbfbd6.jpg";